import * as React from "react"

const SvgComponent = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={22.274}
        height={22.274}
        {...props}
    >
        <g fill="#dedde2">
            <path
                data-name="Rectangle 92"
                d="m1.061 0 21.213 21.213-1.06 1.06L0 1.062z"
            />
            <path data-name="Rectangle 93" d="M10.137 10.387h2v1.5h-2z" />
            <path
                data-name="Rectangle 94"
                d="M0 21.213 21.213 0l1.06 1.06L1.062 22.274z"
            />
        </g>
    </svg>
)

export default SvgComponent
